import { createContext } from "react"

import { LayoutProps } from "~/shared/ui/layouts/main/types"

export const MainTemplateContext = createContext({
	layoutProps: {} as LayoutProps,
	setLayoutProps(newLayoutProps: LayoutProps) {
		void (newLayoutProps)
	}
})
